/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
import React, { useState, useEffect, useRef, useLayoutEffect, Suspense } from 'react';

import { lazy } from '@loadable/component';
import { useDispatch } from 'react-redux';
import MediaQuery from 'react-responsive';
import { useHistory, useLocation } from 'react-router';
import { branch, renderComponent, renderNothing } from 'recompose';
import { withTheme } from 'styled-components';

import { optionChainChartNavigation } from 'actions/optionChain';
import { toggleMobileHeaderDropdown } from 'actions/other';
import { getAllTickers } from 'actions/trade';
import ClickOutside from 'components/click-outside';
import { CenterLoader } from 'components/loader';
import routes from 'constants/routes';
import { noop } from 'helpers';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { isNil } from 'helpers/ramda';
import { device } from 'helpers/screenSizes';

import { disableScrolling, enableScrolling } from '../get_change';
import DesktopHeaderDropdownBox, { MobileHeaderDropdownBox } from './headerDropdownBox';
import styles from './index.module.scss';
import { HeaderDropdownWrapper } from './style';

const HeaderDropdownOptions = lazy(() =>
  import(/* webpackChunkName: "HeaderDropdownOptions" */ './header-dropdown-options')
);

// const MobileHeaderDropdownBox = pure(({ productSymbol, onClick, isSpot }) => (
//   <div className="d-flex product-info" onClick={onClick}>
//     <div className="product-name">
//       <span>{productSymbol}</span>
//       {isSpot && <SpotIcon className="spot-icon" />}
//     </div>
//     <div className="drop-icon">
//       <ChevronDown />
//     </div>
//   </div>
// ));

const HeaderDropdownComponent = props => {
  // If prevPath is universalSearchMobile then we want productDropdown to be open by default.
  // This is because we go to universalSearchMobile from productDropdown and on coming back user should see productDropdown again.
  const location = useLocation();
  const [state, setState] = useState({
    open: location.state?.prevPath === routes.universalSearchMobile,
  });
  const [favClicked, setFavClicked] = useState(false);
  // const dispatch = useDispatch();

  const {
    selected_product,
    productsList,
    userPreferences,
    updateUserPreference,
    userId,
    tradeContractType,
    isLoggedIn,
    expandProductDetails,
  } = props;

  const favorites = userPreferences.favorites || [];
  const history = useHistory();
  const dispatch = useDispatch();
  // const changeOverlay = value =>
  //   dispatch(
  //     toggleOverlay({
  //       overlayType: OVERLAY_TYPES.CONTRACT_DROPDOWN,
  //       value,
  //     })
  //   );

  const dropdownBackdropWrapperElement = useRef(null);

  useEffect(() => {
    const element = document.getElementById('mobile-product-header');
    if (!isNil(element)) {
      if (state.open) {
        expandProductDetails && expandProductDetails(true);
      } else {
        expandProductDetails && expandProductDetails(false);
        enableScrolling();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.open]);

  const onRowClick = () => {
    // e.stopPropagation();
    dispatch(toggleMobileHeaderDropdown(false));
    setState({ open: false });
    expandProductDetails && expandProductDetails(false);
    // changeOverlay(false);
    enableScrolling();
    if (
      selected_product.contract_type === 'call_options' ||
      selected_product.contract_type === 'put_options'
    ) {
      dispatch(optionChainChartNavigation(`MARK:${selected_product.symbol}`));
    }
  };

  const onOptionsBlur = e => {
    if (e.relatedTarget === null) {
      setState({ open: false });
      // changeOverlay(false);
      enableScrolling();
    }
  };

  const toggleDropdown = () => {
    const contractTypes =
      'futures,perpetual_futures,move_options,put_options,call_options,interest_rate_swaps,spreads';
    dispatch(getAllTickers(contractTypes));
    setState(({ open }) => {
      !open ? disableScrolling() : enableScrolling();
      dispatch(toggleMobileHeaderDropdown(!open));
      // changeOverlay(!open);
      return {
        open: !open,
      };
    });
  };

  const onFavoritesClick = (e, productId) => {
    setFavClicked(true);
    e.stopPropagation();
    setState({ open: true });
    updateUserPreference(
      {
        preferences: {
          favorites: favorites.some(pid => pid === productId)
            ? favorites.filter(pid => pid !== productId)
            : favorites.concat(productId),
        },
      },
      { disable_notification: true }
    );
    const product = productsList.find(x => x.id === productId);
    if (typeof product !== 'undefined') {
      const { symbol, contract_type } = product;
      if (!favorites.find(pid => pid === productId)) {
        trackMixpanelEvent('Favorite Marked - Trade', {
          source: 'product dropdown',
          product_name: symbol,
          product_type: contract_type,
        });
      }
    }
    // changeOverlay(true);
  };

  // close popup while clicking browser back button.

  // const { toggleOverlay: closeDropdownOverlay } = props;

  useEffect(() => {
    return () => {
      if (history.action === 'POP') {
        enableScrolling();
      }
    };
  }, [history]);

  useLayoutEffect(() => {
    const container = dropdownBackdropWrapperElement.current;
    if (!container || !state.open) return;
    const { top } = container.getBoundingClientRect();
    container.style.height = `calc(100vh - ${top}px)`;
    if (expandProductDetails) {
      state.open && expandProductDetails(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.open]);

  return (
    (<HeaderDropdownWrapper open={state.open} data-as="HeaderDropdownWrapper">
      <ClickOutside
        onOutsideClick={onOptionsBlur}
        // eslint-disable-next-line jsx-a11y/tabindex-no-positive
        tabIndex="5"
        className="header-dropdown"
      >
        {selected_product ? (
          <>
            <MediaQuery query={device.up.md}>
              <DesktopHeaderDropdownBox
                data-testid="desktop-header-dropdown-box"
                selected_product={selected_product}
                onClick={toggleDropdown}
                isOpen={state.open}
                isLoggedIn={isLoggedIn}
              />
            </MediaQuery>
            <MediaQuery query={device.down.md}>
              <MobileHeaderDropdownBox
                selected_product={selected_product}
                openDropdown={toggleDropdown}
                isOpen={state.open}
                isLoggedIn={isLoggedIn}
              />
            </MediaQuery>
          </>
        ) : null}
        {state.open && (
          <div
            ref={dropdownBackdropWrapperElement}
            className={`d-flex ${styles['dropdown-backdrop-wrapper']}`}
            data-palette="HeaderDropdownComponent">
            <Suspense fallback={<CenterLoader />}>
              <HeaderDropdownOptions
                productsList={productsList}
                onRowClick={onRowClick}
                activeRowId={selected_product.id}
                handleClick={onFavoritesClick}
                userPreferences={userPreferences}
                isFavClicked={favClicked}
                userId={userId}
                toggleDropdown={toggleDropdown}
                tradeContractType={tradeContractType}
                isOpen={state.open}
                isLoggedIn={isLoggedIn}
                selectedProduct={selected_product}
              />
            </Suspense>
            <div
              data-testid="header-dropdown-backdrop"
              className={styles.backdrop}
              onClick={onOptionsBlur}
              onKeyDown={noop}
              role="presentation"
            />
          </div>
        )}
      </ClickOutside>
      {/* <MediaQuery query={device.down.md}>
        {selected_product.contract_type !== 'spot' && (
          <div className="col-md-4 col-xs-6 product-tooltip">
            <ProductToolTip product={selected_product} />
          </div>
        )}
      </MediaQuery> */}
    </HeaderDropdownWrapper>)
  );
};

export const HeaderDropdown = branch(
  props => !props.isblackListedPath,
  renderComponent(withTheme(HeaderDropdownComponent)),
  renderNothing
)();
